var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-filter"},[_c('div',{staticClass:"popper-filter__content"},[_c('r-radio-group',{attrs:{"button-list":_vm.filterValue,"active":_vm.defaultValue},on:{"change":_vm.toggleValue}})],1),_c('r-button',{attrs:{"type":"primary"},on:{"click":_vm.prepareData}},[_vm._v(" "+_vm._s(_vm.$t(`radio-filter:accept`))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }